//export {  default as DashboardReview} from "./TeacherReview/DashboardReview/DashboardReview";
//export {  default as StoriesReview} from "./TeacherReview/StoriesReview/StoriesReview";
//export * from "./TeacherReview/StoryReview/StoryReview";
import { lazy } from 'react';
import { withRouter } from "react-router-dom";

export const DashboardReview = withRouter(lazy(() => import('./TeacherReview/DashboardReview/DashboardReview')));
export const StoriesReview = withRouter(lazy(() => import('./TeacherReview/StoriesReview/StoriesReview')));
export const StoryReview = withRouter(lazy(() => import('./TeacherReview/StoryReview/StoryReview')));
